import React, { useEffect } from "react";
import { useRef } from "react";
import closeIcon from "../../assets/images/svg/cross.svg";
import { clickableButton } from "../../utils/constants";

const Modal = ({
  children,
  onClose,
  open,
  width,
  minWidth,
  title,
  showCloseIcon,
  modalContainerClass,
  isTitleLeft,
  left,
  modalStyle,
  mdlStyle,
  submitted,
  dialogId = "",
  announcement = "",
  modalId = "",
  modalWrapperClass = "",
}) => {
  const modalRef = useRef(null);

  const handleTabKeyPress = (event) => {
    const modalElement = modalRef.current;
    //add any focusable HTML element you want to include to this string
    const focusableElements = modalElement.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
    );

    if (event.key === "Tab") {
      const focusableElementsArray = Array.from(focusableElements);
      const focusedIndex = focusableElementsArray.indexOf(
        document.activeElement,
      );

      if (event.shiftKey) {
        // Shift + Tab pressed
        if (focusedIndex === 0) {
          event.preventDefault();
          focusableElementsArray[focusableElementsArray.length - 1].focus();
        }
      } else {
        // Tab pressed
        if (focusedIndex === focusableElementsArray.length - 1) {
          event.preventDefault();
          focusableElementsArray[0].focus();
        }
      }
    }
  };

  const handleEscapeKeyPress = (event) => {
    if (event.key === "Escape") {
      onClose(false);
    }
  };

  useEffect(() => {
    if (document.querySelector(".is-active.modal")) {
      document.getElementsByTagName("html")[0].style.overflow = "hidden";
    } else {
      document.getElementsByTagName("html")[0].style.overflow = "auto";
    }

    if (open) {
      const modalElement = modalRef.current;

      modalElement.addEventListener("keydown", handleTabKeyPress);
      modalElement.addEventListener("keydown", handleEscapeKeyPress);

      setTimeout(() => {
        modalElement?.focus();
      }, 0);

      return () => {
        modalElement.removeEventListener("keydown", handleTabKeyPress);
        modalElement.removeEventListener("keydown", handleEscapeKeyPress);
      };
    }

    if (submitted) modalRef.current.focus();
  }, [open, submitted]);

  useEffect(() => {
    const announcer = document.getElementById("aria-announcer");

    if (announcement) {
      if (open && announcer) {
        announcer.textContent = `${announcement} modal opened`;
      }

      if (!open && announcer.textContent) {
        announcer.textContent = `${announcement} modal closed`;
        setTimeout(() => {
          announcer.textContent = "";
        }, 500);
      }
    }
  }, [open, announcement]);

  return (
    <>
      <div
        id="aria-announcer"
        className="sr-only hidden-announcer"
        aria-live="assertive"
        aria-atomic="true"
      ></div>
      <div className={open ? `is-active modal ${modalWrapperClass}` : "modal"}>
        <div
          onClick={onClose}
          style={{ ...mdlStyle }}
          className={`modal-background no_scroll`}
        ></div>

        <div
          id={modalId}
          style={{
            width: width || "552px",
            minWidth: minWidth || "552px",
            minHeight: "200px",
            maxHeight: "97vh",
            ...modalStyle,
          }}
          className={`${
            modalContainerClass ? modalContainerClass : ""
          } modal_container`}
          tabIndex={-1}
          ref={modalRef}
          role="dialog"
          aria-modal="true"
          aria-labelledby={dialogId}
        >
          <div className="flex is-justify-content-end title-wrapper">
            <h2
              id={dialogId}
              className="modal_title"
              style={!isTitleLeft ? { left: left } : {}}
            >
              {title}
            </h2>
            {showCloseIcon === false ? (
              <></>
            ) : (
              <>
                <span className="modal-close-button-wrapper" onClick={onClose}>
                  <button
                    onClick={onClose}
                    style={clickableButton}
                    className="modal_close_btn"
                    tabIndex={0}
                    aria-label="Close"
                  >
                    <img
                      width={"20px"}
                      className=" clickable"
                      src={closeIcon}
                      alt="close"
                    />
                  </button>
                </span>
              </>
            )}
          </div>
          <div>{children}</div>
        </div>
      </div>
    </>
  );
};

export default Modal;
